import React from 'react';
export const MoreVertical = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4142 3.58579C14.1953 4.36684 14.1953 5.63317 13.4142 6.41422C12.6332 7.19527 11.3668 7.19527 10.5858 6.41422C9.80474 5.63317 9.80474 4.36684 10.5858 3.58579C11.3668 2.80474 12.6332 2.80474 13.4142 3.58579ZM13.4142 10.5858C14.1953 11.3668 14.1953 12.6332 13.4142 13.4142C12.6332 14.1953 11.3668 14.1953 10.5858 13.4142C9.80474 12.6332 9.80474 11.3668 10.5858 10.5858C11.3668 9.80475 12.6332 9.80475 13.4142 10.5858ZM13.4142 20.4142C14.1953 19.6332 14.1953 18.3668 13.4142 17.5858C12.6332 16.8047 11.3668 16.8047 10.5858 17.5858C9.80474 18.3668 9.80474 19.6332 10.5858 20.4142C11.3668 21.1953 12.6332 21.1953 13.4142 20.4142Z",
  fill: "currentColor"
}));